import '../css_styles/button_styles.css'
import '../css_styles/window_canvas_styles.css'

// imports relevant for HTTP calls
import DisplayException from '../error_messages/DisplayException';
import CircleLoader from 'react-spinners/CircleLoader';
import { SERVER_URL } from '../config_server_url';

// ----- Import Workflow Elements --------
import SampleViewer from './workflow_elements/SampleViewer'
import InfoExperimentalProcedure from './InfoExperimentalProcedureViewer';
import UserSessionContext from '../user_session/context_user_session';
import { useContext, useState, useEffect } from 'react';

function WorkflowViewer(props) {


    const [title, setTitle] = useState('')
    const [workflow, setWorkflow] = useState({samples:[]});
    const [descriptionProcedure, setDesciptionProcedure] = useState(null)
    
    // ------------------ Load User Session Information ---------------------------------
    const [isLoading, setIsLoading] = useState(false);
    // ------------------ Display HTTP/Server Exceptions ---------------------------------
    const [Exception, setException] = useState(false);
    const [ExceptionMessage, setExceptionMessage] = useState('');
    const usr_session_ctx = useContext(UserSessionContext);


    useEffect(() => {
        if (props.uuid_experimental_setup !== '') {
            setIsLoading(true);
            let exp_setup_uuid = props.uuid_experimental_setup;
            fetch(`${SERVER_URL}/current_project/load_experimental_setup/`, {method: 'POST',
                                                            headers:{'Content-Type':'application/json',
                                                                     'uuid_tenant': usr_session_ctx.uuid_tenant},
                                                            body:JSON.stringify(exp_setup_uuid)})
            .then((res) => {
                if(!res.ok) {
                    throw new Error(`HTTP error ${res.status}`);
                }
                return res.json();
            })
            .then((data) => {
                setWorkflow(data.data.workflow);
                setTitle(data.data.title);
                setDesciptionProcedure(data.data.description);
                setIsLoading(false); 
            })
            .catch((err) => {
                setException(true);
                setExceptionMessage(`HTTPException: err_msg=${err.message}`);
            });
        }
    }, [props.uuid_experimental_setup]);


    let samples = workflow.samples.map((sample, sampleIndex) => (
        <SampleViewer sid={`${sampleIndex}`}
                key={`${sampleIndex}`}
                sample={sample}/>
        ));

    let action_panel = (<></>);
    if(typeof props.hideActionPanel === 'undefined' || !props.hideActionPanel) {
        action_panel = (<>
                    <div style={{position: 'relative', display:'flex', marginLeft: '10px', marginTop:'10px', paddingTop:'10px',
                            marginBottom:'0px', height:'fit-content', width:'fit-content'}}>   
                        <button className={'tableButton'} onClick={props.onEdit} style={{width: '95px', paddingBottom: '3px', paddingTop: '3px', marginBottom: '0px'}}>Edit</button>
                        {/* <button className={'tableButton'} style={{marginRight: '10px', width: '95px', paddingBottom: '3px', paddingTop: '3px', marginBottom: '0px'}} >Delete</button>
                        <button className={'tableButton'} style={{width: '95px', paddingBottom: '3px', paddingTop: '3px', marginBottom: '0px'}} >Load</button>
                        <button className={'tableButton'} style={{width: '95px', paddingBottom: '3px', paddingTop: '3px', marginBottom: '0px'}} >Create New</button> */}
                    </div>  
                </>);
    }

    let viewer = (<></>)
    if(isLoading && !Exception){
        viewer = (<div className = {'builder_canvas'} >
                    <div style = {{position:'absolute', top:'5px', display: 'flex', justifyContent: 'center', alignItems: 'center',  width:'100%', height:'100%'}}>
                        <CircleLoader loading={isLoading} size={40} color='var(--aixelo-green)' />
                    </div>
                </div>);
    }

    if(Exception){
        viewer = (<>
                    <div className = {'builder_canvas'} >
                        <DisplayException>
                            {ExceptionMessage}
                        </DisplayException>  
                    </div>
                </>);
    }


    if(!isLoading && !Exception){
        viewer = (<>
                    <div className = {'viewer_canvas'} style={{height:props.height-120}}>
                        <p style = {{marginLeft: '20px', marginTop: '10px', marginBottom: '3px', fontSize: '18px', fontWeight:'bold', position: 'relative', width:'94%'}} >
                            Title: {title}
                        </p>
                        <div style = {{marginLeft: '20px', marginBottom: '15px', fontSize: '12px', position: 'relative', width:'fit-content'}} >
                            uuid: {props.uuid_experimental_setup}
                        </div>
                        <div style = {{width: `${props.width * 0.89 - 40}px`, marginLeft: '20px', background: 'white', marginTop: '10px', marginBottom: '20px', border:'0.5px solid var(--aixelo-gray-light)'}}>
                                <InfoExperimentalProcedure 
                                    width={props.width*0.89 - 60}
                                    description={descriptionProcedure} />
                            </div>
                        <div style={{position: 'relative', marginLeft:'20px', height:'fit-content', overflow:'auto'}}>
                            {samples}
                        </div>
                    </div>
                    {action_panel}
                </>
                );
    }
    return (<>
                {viewer}
            </>);
}

export default WorkflowViewer